import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-077bf099"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arg-header" }
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "button" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "control" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Maximum Quality", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "none", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "010", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "030", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "050", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "080", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "100", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "200", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "300", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "400", -1))
const _hoisted_24 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "control" }
const _hoisted_27 = { class: "checkbox" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = { class: "checkbox" }
const _hoisted_30 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JsonEditor = _resolveComponent("JsonEditor")!
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Preview" }, {
    default: _withCtx(() => [
      (_ctx.pkgData)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, {
            key: 0,
            title: "Arguments",
            expandable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkgData.previewArguments, (arg, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "arg",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                          class: "input",
                          type: "text",
                          placeholder: "Name",
                          "onUpdate:modelValue": ($event: any) => ((arg.name) = $event)
                        }, null, 8, _hoisted_4), [
                          [_vModelText, arg.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                          class: "button",
                          onClick: ($event: any) => (_ctx.visible[i] = !_ctx.visible[i])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass('fas fa-' + (_ctx.visible[i] ? 'eye' : 'eye-slash'))
                          }, null, 2)
                        ], 8, _hoisted_6)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.picked) = $event)),
                            value: arg
                          }, null, 8, _hoisted_9), [
                            [_vModelRadio, _ctx.picked]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          class: "button",
                          onClick: ($event: any) => (_ctx.remove(i))
                        }, _hoisted_13, 8, _hoisted_11)
                      ])
                    ])
                  ]),
                  (_ctx.visible[i])
                    ? (_openBlock(), _createBlock(_component_JsonEditor, {
                        key: 0,
                        modelValue: arg.arguments,
                        "onUpdate:modelValue": ($event: any) => ((arg.arguments) = $event),
                        schema: _ctx.pkgData.schema
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "schema"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: "button is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
              }, "Add preview argument")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pkgData)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, {
            key: 1,
            title: "Maximum Quality"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                class: "select is-small",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pkgData.previewSettings.maximumQuality) = $event))
              }, _hoisted_24, 512), [
                [_vModelSelect, _ctx.pkgData.previewSettings.maximumQuality]
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pkgData && _ctx.picked)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, {
            key: 2,
            title: "Resolver"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  class: "button is-small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openResolvedBook()))
                }, " Resolve book with current preview ")
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.automated) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.automated]
                  ]),
                  _createTextVNode(" Automated ")
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.renderFirst) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.renderFirst]
                  ]),
                  _createTextVNode(" Render first view first spread ")
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input is-small",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rendererFrontendUrl) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.rendererFrontendUrl]
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}